var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeavyLoad = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 419.654,
  height: 142
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 85",
  d: "M.337 75.583S101.994 67 206.744 67s212.593 8.583 212.593 8.583",
  fill: "none",
  stroke: "#6e6e6e",
  strokeWidth: 8
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 897",
  fill: "#434343",
  d: "M25.337 0h31v142h-31z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 900",
  fill: "#434343",
  d: "M330.337 0h31v142h-31z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 898",
  fill: "#434343",
  d: "M58.337 0h31v142h-31z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 899",
  fill: "#434343",
  d: "M363.337 0h31v142h-31z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 901",
  fill: "#6e6e6e",
  d: "M90.337 55h7v29h-7z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 902",
  fill: "#6e6e6e",
  d: "M322.337 55h7v29h-7z"
})));
export { SvgHeavyLoad as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='419.654' height='142' viewBox='0 0 419.654 142'%3e %3cg id='heavy-load' transform='translate(-140.663 -334)'%3e %3cpath id='Path_85' data-name='Path 85' d='M0,0S101.657-8.583,206.407-8.583,419,0,419,0' transform='translate(141 409.583)' fill='none' stroke='%236e6e6e' stroke-width='8'/%3e %3crect id='Rectangle_897' data-name='Rectangle 897' width='31' height='142' transform='translate(166 334)' fill='%23434343'/%3e %3crect id='Rectangle_900' data-name='Rectangle 900' width='31' height='142' transform='translate(471 334)' fill='%23434343'/%3e %3crect id='Rectangle_898' data-name='Rectangle 898' width='31' height='142' transform='translate(199 334)' fill='%23434343'/%3e %3crect id='Rectangle_899' data-name='Rectangle 899' width='31' height='142' transform='translate(504 334)' fill='%23434343'/%3e %3crect id='Rectangle_901' data-name='Rectangle 901' width='7' height='29' transform='translate(231 389)' fill='%236e6e6e'/%3e %3crect id='Rectangle_902' data-name='Rectangle 902' width='7' height='29' transform='translate(463 389)' fill='%236e6e6e'/%3e %3c/g%3e %3c/svg%3e";